/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage50 = createReactComponent("outline", "percentage-50", "IconPercentage50", [["path", { "d": "M12 21a9 9 0 0 0 0 -18m0 0v18", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

export { IconPercentage50 as default };
//# sourceMappingURL=IconPercentage50.mjs.map
